import { Link, useLocation } from 'react-router-dom'
import NotificationBell from '@/components/navbar/NotificationBell'
import { Button } from '@/components/ui'
import { FeedbackIcon } from '@/icons'
import { useAuthStore } from '@/store/authStore'

interface NavbarAccountActionsProps {
  onOpenFeedback: () => void
  onLogout: () => void
}

/** Authenticated: admin link, feedback, notifications, username, logout. Otherwise: login / sign up. */
export function NavbarAccountActions({ onOpenFeedback, onLogout }: NavbarAccountActionsProps) {
  const { isAuthenticated, user } = useAuthStore()
  const location = useLocation()

  if (!isAuthenticated) {
    return (
      <>
        <Button as={Link} to="/login" variant="secondary" size="sm">
          Login
        </Button>
        <Button as={Link} to="/signup" size="sm" className="hidden sm:inline-flex">
          Sign Up
        </Button>
      </>
    )
  }

  return (
    <>
      {user?.admin && (
        <Link
          to="/admin"
          aria-current={location.pathname.startsWith('/admin') ? 'page' : undefined}
          className="text-sm text-purple-400 hover:text-purple-300 font-medium hidden md:inline"
        >
          Admin
        </Link>
      )}
      <Button
        variant="ghost"
        size="icon"
        onClick={onOpenFeedback}
        className="hidden md:inline-flex"
        title="Send Feedback"
        aria-label="Send feedback"
        icon={<FeedbackIcon className="w-5 h-5" />}
      />
      <NotificationBell />
      <Link
        to="/settings"
        className="text-secondary text-sm hidden md:inline truncate max-w-[150px] hover:text-primary"
      >
        {user?.username}
      </Link>
      <Button variant="secondary" size="sm" onClick={onLogout} className="hidden md:inline-flex">
        Logout
      </Button>
    </>
  )
}
